import WebSpeechRecorder from './WebSpeechRecorder';
import DeepgramRecorder from './DeepgramRecorder';
import AzureSpeechRecorder from './AzureSpeechRecorder';

const RecorderFactory = {
  create: (type, { ref, ...props }) => {
    switch (type) {
      case 'webspeech':
        return <WebSpeechRecorder ref={ref} {...props} />;
      case 'deepgram':
        return <DeepgramRecorder ref={ref} {...props} />;
      case 'azure':
      default:
        return <AzureSpeechRecorder ref={ref} {...props} />;
    }
  }
};

export default RecorderFactory; 